jQuery( document ).ready(function() {
// jQuery('#shipping-time').shipTime(); 
//shipping time

 var fromDate = Date.today().addDays(1);
  if (fromDate.is().saturday() || fromDate.is().sunday()) {
    fromDate = fromDate.next().monday().addDays(1);
  } 
  var toDate = Date.today().addDays(4);
  if (toDate.is().saturday() || toDate.is().sunday()) {
    toDate = toDate.next().monday(); 
  } 
  
 document.getElementById("date_change").innerHTML=toDate.toString('dddd MMMM dS'); 

 });